<div class="container-countries-dropdown">
  @if (label) {
    <span class="label">{{ 'selectCountries.label' | cxTranslate }}</span>
  }

  <div
    class="fake-select"
    (click)="open()"
    (keyup.enter)="open()"
    (keyup.space)="open()"
    [attr.tabindex]="0"
    [class.disabled]="containerIsDisabled"
    [class.ng-invalid]="form?.get(controlName)?.invalid && (form?.get(controlName)?.dirty || form?.get(controlName)?.touched)"
  >
    <span class="selected-country" [ngClass]="{ 'is-active': listStatus }">
      @if (country?.name) {
        <div class="ipv_flag-box m-r-4">
          <div class="ipv_{{ country!.isocode?.toLowerCase() }} ipv_flag"></div>
        </div>

        @if (displaySelectedContryName) {
          {{ country?.name }}
        }

        @if (displaySelectedContryDiallingCode) {
          {{ country?.diallingCode }}
        }
      } @else {
        @if (placeholder) {
          <span class="placeholder"> {{ placeholder | cxTranslate }} </span>
        }
      }
    </span>

    <input #input type="text" class="input-filter" [ngClass]="{ 'is-active': listStatus }" (keyup)="filter(input.value)" />

    <span class="icon material-symbols-outlined"> keyboard_arrow_down </span>
  </div>

  <ul #container class="ipv_country-list" [ngClass]="{ 'is-active': listStatus }">
    <li *ngFor="let item of countries" [attr.aria-label]="item.name" value="{{ item.isocode }}" class="ipv_country">
      <button type="button" (click)="selectCountry(item)">
        <div class="ipv_flag-box">
          <div class="ipv_{{ item.isocode?.toLowerCase() }} ipv_flag"></div>
        </div>

        <span class="ipv_country-name" title="{{ item.name }}">{{ item.name }}</span>
        <span class="ipv_dial-code">
          @if (!hideDialingCode) {
            {{ item.diallingCode }}
          }
        </span>
      </button>
    </li>
  </ul>
</div>
